import { create } from 'zustand';

import { AxiosHttpClient } from 'src/http';
import { API_URL } from 'src/config-global';
import { CustomContentRepository } from 'src/repositories/custom-content/custom-content.repository';

import { EventData } from 'src/types/custom-content/eventData';
import { BusinessUnit } from 'src/types/custom-content/businessUnit';

type States = {
  isLoading: boolean;
  businessUnity?: BusinessUnit;
  eventData?: EventData;
  ids: {
    BUId: string;
    eventId: string;
  }
};

type Actions = {
  getCustomContent: (bu: string, event: string) => Promise<{ BUData: BusinessUnit, eventData: EventData }>
};

type CustomContent = Actions & States;

const initialValues = {
  isLoading: false,
  businessUnity: undefined,
  eventData: undefined,
  ids: {
    BUId: '',
    eventId: ''
  }
};
const api = new AxiosHttpClient(API_URL)
const repository = new CustomContentRepository(api)

export const useCustomContent = create<CustomContent>((set: any, get: any) => ({
  ...initialValues,

  async getCustomContent(bu: string, event: string) {
    const response = await repository.getCustomContent({ buURL: bu, eventURL: event })
    if (response.isLeft()) {
      throw new Error
    } else {
      set({
        businessUnity: response.value.BUData,
        eventData: response.value.eventData,
        ids: {
          BUId: response.value.BUData._id || response.value.BUData.id,
          eventId: response.value.eventData._id
        }
      })
      return response.value
    }
  },

}));
